import { useClientPortalInternalData } from '../../../hooks/use-client-portal-internal-data'

export const useVisaBulletin = () => {
  const { dataClientPortalInternal, navigateToCaseDetail } = useClientPortalInternalData()

  const visaBulletinData = dataClientPortalInternal?.visaBulletin
  const visaBulletinTrendData = dataClientPortalInternal?.visaBulletinTrend
  const portalOption = dataClientPortalInternal?.portalOption
  const priorityDate = dataClientPortalInternal?.caseInfo.priorityDate

  const noData = !visaBulletinData
  const showsVisaBulletinInfo = portalOption?.visaBulletin
  const showsVisaBulletinTrend = portalOption?.visaBulletinTrend

  return {
    noData,
    visaBulletinData,
    visaBulletinTrendData,
    priorityDate,
    showsVisaBulletinInfo,
    showsVisaBulletinTrend,
    navigateToCaseDetail,
  }
}
